// import React from 'react';
// import { styled, Theme } from '@material-ui/core/styles';

// import MenuBar from './components/MenuBar/MenuBar';
// import MobileTopMenuBar from './components/MobileTopMenuBar/MobileTopMenuBar';
// import PreJoinScreens from './components/PreJoinScreens/PreJoinScreens';
// import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
// import RecordingNotifications from './components/RecordingNotifications/RecordingNotifications';
// import Room from './components/Room/Room';

// import useHeight from './hooks/useHeight/useHeight';
// import useRoomState from './hooks/useRoomState/useRoomState';

// const Container = styled('div')({
//   display: 'grid',
//   gridTemplateRows: '1fr auto',
// });

// const Main = styled('main')(({ theme }: { theme: Theme }) => ({
//   overflow: 'hidden',
//   paddingBottom: `${theme.footerHeight}px`, // Leave some space for the footer
//   background: 'black',
//   [theme.breakpoints.down('sm')]: {
//     paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`, // Leave some space for the mobile header and footer
//   },
// }));

// export default function App() {
//   const roomState = useRoomState();

//   // Here we would like the height of the main container to be the height of the viewport.
//   // On some mobile browsers, 'height: 100vh' sets the height equal to that of the screen,
//   // not the viewport. This looks bad when the mobile browsers location bar is open.
//   // We will dynamically set the height with 'window.innerHeight', which means that this
//   // will look good on mobile browsers even after the location bar opens or closes.
//   const height = useHeight();

//   return (
//     <Container style={{ height }}>
//       {roomState === 'disconnected' ? (
//         <PreJoinScreens />
//       ) : (
//         <Main>
//           <ReconnectingNotification />
//           <RecordingNotifications />
//           <MobileTopMenuBar />
//           <Room />
//           <MenuBar />
//         </Main>
//       )}
//     </Container>
//   );
// }




import React, { useEffect, useState } from 'react';
import { styled, Theme } from '@material-ui/core/styles';

import MenuBar from './components/MenuBar/MenuBar';
import MobileTopMenuBar from './components/MobileTopMenuBar/MobileTopMenuBar';
import PreJoinScreens from './components/PreJoinScreens/PreJoinScreens';
import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
import RecordingNotifications from './components/RecordingNotifications/RecordingNotifications';
import Room from './components/Room/Room';
import InterviewCompleteScreen from './components/PreJoinScreens/InterviewCompleteScreen';

import useHeight from './hooks/useHeight/useHeight';
import useRoomState from './hooks/useRoomState/useRoomState';
import useVideoContext from './hooks/useVideoContext/useVideoContext';
import { TwilioError } from 'twilio-video';
import { VIDEO_API_BASE } from './UrlFiles/UrlFiles';

const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: '1fr auto',
});

const Main = styled('main')(({ theme }: { theme: Theme }) => ({
  overflow: 'hidden',
  paddingBottom: `${theme.footerHeight}px`,
  background: 'black',
  [theme.breakpoints.down('sm')]: {
    paddingBottom: `${theme.mobileFooterHeight + theme.mobileTopBarHeight}px`,
  },
}));

const sessionBlockedStyle: React.CSSProperties = {
  minHeight: '100vh',
  background: '#0f172a',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  padding: '24px',
  textAlign: 'center',
};

export default function App() {
  const roomState = useRoomState();
  const { room } = useVideoContext();
  const height = useHeight();

  const [isCompleted, setIsCompleted] = useState(false);
  const [sessionBlocked, setSessionBlocked] = useState(false);
  const [sessionBlockMessage, setSessionBlockMessage] = useState('');

  const params = new URLSearchParams(window.location.search);
  const isNewFlow = !!params.get('role') && !!params.get('join_token');
  const roomName = window.location.pathname.split('/room/')[1];

  useEffect(() => {
    if (!isNewFlow || !roomName) return;
    fetch(`${VIDEO_API_BASE}/video/session-status/${roomName}`)
      .then(r => r.json())
      .then(data => {
        if (data.status === 'completed') {
          setSessionBlocked(true);
          setSessionBlockMessage('This interview session has already ended and is no longer available.');
        }
      })
      .catch(() => {});
  }, [isNewFlow, roomName]);

useEffect(() => {
  if (!room) return;
  const handleDisconnected = (_: any, error?: TwilioError) => {
    if (!error || (error as any).code === 53118) {
      setIsCompleted(true);
    }
  };
  room.on('disconnected', handleDisconnected);
  return () => { room.off('disconnected', handleDisconnected); };
}, [room]);

  if (sessionBlocked) {
    return (
      <div style={sessionBlockedStyle}>
        <div style={{
          width: '64px', height: '64px', borderRadius: '50%',
          background: 'rgba(239,68,68,0.15)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', margin: '0 auto',
        }}>
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#f87171" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <p style={{ color: '#ffffff', fontSize: '20px', fontWeight: 700, margin: 0 }}>
          Session Unavailable
        </p>
        <p style={{ color: '#94a3b8', maxWidth: '360px', margin: 0, lineHeight: 1.6 }}>
          {sessionBlockMessage}
        </p>
        <button
          onClick={() => { window.location.href = 'https://www.jobexcello.com'; }}
          style={{
            background: '#0A66C2', color: 'white', border: 'none',
            borderRadius: '24px', padding: '10px 32px', fontSize: '15px',
            fontWeight: 600, cursor: 'pointer', marginTop: '8px',
          }}
        >
          Go to JobExcello
        </button>
      </div>
    );
  }

  if (isCompleted) {
    return <InterviewCompleteScreen />;
  }

  return (
    <Container style={{ height }}>
      {roomState === 'disconnected' ? (
        <PreJoinScreens />
      ) : (
        <Main>
          <ReconnectingNotification />
          <RecordingNotifications />
          <MobileTopMenuBar />
          <Room />
          <MenuBar />
        </Main>
      )}
    </Container>
  );
}